module.exports = __webpack_public_path__ + "static/media/8.435daf14.jpg";